export default {
  namespaced: true,
  state: () => ({
    showUnitInfo: true,
    showPrice: true,
    units: [
      { UnitNumber: '0001', _UnitStatus: '' },
      { UnitNumber: '0002', _UnitStatus: '' },
      { UnitNumber: '0003', _UnitStatus: '' },
      { UnitNumber: '0004', _UnitStatus: '' },
      { UnitNumber: '0005', _UnitStatus: '' },
      { UnitNumber: '0006', _UnitStatus: '' },
      { UnitNumber: '0007', _UnitStatus: '' },
      { UnitNumber: '0008', _UnitStatus: '' },
      { UnitNumber: '0009', _UnitStatus: '' },
      { UnitNumber: '0010', _UnitStatus: '' },
      { UnitNumber: '0011', _UnitStatus: '' },
      { UnitNumber: '0012', _UnitStatus: '' },
      { UnitNumber: '0013', _UnitStatus: '' },
      { UnitNumber: '0014', _UnitStatus: '' },
      { UnitNumber: '0015', _UnitStatus: '' },
      { UnitNumber: '0016', _UnitStatus: '' },
      { UnitNumber: '0017', _UnitStatus: '' },
      { UnitNumber: '0018', _UnitStatus: '' },
      { UnitNumber: '0019', _UnitStatus: '' },
      { UnitNumber: '0020', _UnitStatus: '' },
      { UnitNumber: '0021', _UnitStatus: '' },
      { UnitNumber: '0022', _UnitStatus: '' },
      { UnitNumber: '0023', _UnitStatus: '' },
      { UnitNumber: '0024', _UnitStatus: '' },
      { UnitNumber: '0025', _UnitStatus: '' },
      { UnitNumber: '0026', _UnitStatus: '' },
      { UnitNumber: '0027', _UnitStatus: '' },
      { UnitNumber: '0028', _UnitStatus: '' },
      { UnitNumber: '0029', _UnitStatus: '' },
      { UnitNumber: '0030', _UnitStatus: '' },
      { UnitNumber: '0031', _UnitStatus: '' },
      { UnitNumber: '0032', _UnitStatus: '' },
      { UnitNumber: '0033', _UnitStatus: '' },
      { UnitNumber: '0034', _UnitStatus: '' },
      { UnitNumber: '0035', _UnitStatus: '' },
      { UnitNumber: '0036', _UnitStatus: '' },
      { UnitNumber: '0037', _UnitStatus: '' },
      { UnitNumber: '0038', _UnitStatus: '' },
      { UnitNumber: '0039', _UnitStatus: '' },
      { UnitNumber: '0040', _UnitStatus: '' },
      { UnitNumber: '0041', _UnitStatus: '' },
      { UnitNumber: '0042', _UnitStatus: '' },
      { UnitNumber: '0043', _UnitStatus: '' },
      { UnitNumber: '0044', _UnitStatus: '' },
      { UnitNumber: '0045', _UnitStatus: '' },
      { UnitNumber: '0046', _UnitStatus: '' },
      { UnitNumber: '0047', _UnitStatus: '' },
      { UnitNumber: '0048', _UnitStatus: '' },
      { UnitNumber: '0049', _UnitStatus: '' },
      { UnitNumber: '0050', _UnitStatus: '' },
      { UnitNumber: '0051', _UnitStatus: '' },
      { UnitNumber: '0052', _UnitStatus: '' },
      { UnitNumber: '0053', _UnitStatus: '' },
      { UnitNumber: '0054', _UnitStatus: '' },
      { UnitNumber: '0055', _UnitStatus: '' },
      { UnitNumber: '0056', _UnitStatus: '' },
      { UnitNumber: '0057', _UnitStatus: '' },
      { UnitNumber: '0058', _UnitStatus: '' },
      { UnitNumber: '0059', _UnitStatus: '' },
      { UnitNumber: '0060', _UnitStatus: '' },
      { UnitNumber: '0061', _UnitStatus: '' },
      { UnitNumber: '0062', _UnitStatus: '' },
      { UnitNumber: '0063', _UnitStatus: '' },
    ],
  }),
  mutations: {
    set (state, { key, value }) {
      state[key] = value
    },
  },
}
